import { ProvisioningContext } from "src/app/models/provisioning-context.model";

export class ProvisioningContextState {
	value: ProvisioningContext | undefined
}

export const provisioningContextInitialState: ProvisioningContextState = {
	value: undefined
};
